import { FunctionComponent, useContext } from 'react';
import classNames from 'classnames';
import { HiddenNavContext } from 'providers/hiddenNav';

import CookiesPanel from 'components/layout/CookiePanel';
import PlaceholderCover from 'components/wrappers/Public/PlaceholderCover';

import Footer from './blocks/Footer';
import Topbar from './blocks/Topbar';
import TopbarMobile from './blocks/TopbarMobile';
import { Props } from './index';
import StyledComponent from './styles';

const WrapperPublic: FunctionComponent<Props> = ({ children }) => {
    const [isHidden]: [boolean] = useContext(HiddenNavContext);

    return (
        <>
            <StyledComponent className={classNames('wrapper-public', {
                'disabled-padding': Boolean(isHidden),
            })}
            >
                {/*<Topbar*/}
                {/*    className={classNames({*/}
                {/*        'hidden-nav': Boolean(isHidden),*/}
                {/*    })}*/}
                {/*/>*/}
                {/*<TopbarMobile*/}
                {/*    className={classNames({*/}
                {/*        'hidden-nav': Boolean(isHidden),*/}
                {/*    })}*/}
                {/*/>*/}
                {/*<div className="wrapper-content">*/}
                {/*    {children}*/}
                {/*</div>*/}
                {/*<Footer />*/}
                {/*<CookiesPanel />*/}
                <PlaceholderCover />
            </StyledComponent>
        </>
    );
};

export default WrapperPublic;
